// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"LoginUser-LoginUser-noMargin-28143fd2","registerNow":"LoginUser-LoginUser-registerNow-f4f37a4a","rememberMeCheckbox":"LoginUser-LoginUser-rememberMeCheckbox-c936b85e"};